// Wizard Form Validator
// Handles validation and error display for the item wizard form

export default class WizardValidator {
  constructor() {
    this.errors = [];
  }

  validateFields(state, fixedAttributes, variableAttributes, collectAllAttributes, collectVariableAttributes, isEditMode = false, validateLocation = true, bulkCreateMode = false) {
    this.errors = [];
    // Catalogue style required (manual selects or UUID field both set hidden item[catalogue_item_id])
    if (!isEditMode) {
      const catalogueItemId = document.querySelector('input[name="item[catalogue_item_id]"]')?.value;
      if (!catalogueItemId || catalogueItemId.trim() === '') {
        this.errors.push({
          field: 'catalogue_item_reference',
          message: 'Select a catalogue style (dropdowns above) or paste a valid catalogue item UUID.',
        });
      }
    }

    // Skip location validation in edit mode
    if (!isEditMode && validateLocation) {
      // Validate Location (parent)
      const locationId = state.location.locationId;
      if (!locationId) {
        this.errors.push({ field: 'location_id', message: 'Location is required' });
      }
      
      // Validate Child Location
      const childLocationId = state.location.childLocationId;
      const locationMode = state.location.mode;
    
      if (!childLocationId && locationId) {
        this.errors.push({ field: 'child_location_id', message: 'Sub Location is required' });
      } else {
        // For building locations, verify child has floorplan
        // For transit/store locations, floorplan is not required
        if (locationMode === 'building' || locationMode === 'store') {
          const locationData = state.location.locationData;
          if (locationData) {
            const findChildById = (node, id) => {
              if (!node) return null;
              if (String(node.id) === String(id)) return node;
              if (!node.children || !Array.isArray(node.children)) return null;

              for (const child of node.children) {
                const found = findChildById(child, id);
                if (found) return found;
              }

              return null;
            };

            const pathToNode = (node, id, path = []) => {
              if (!node) return null;
              const next = path.concat(node);
              if (String(node.id) === String(id)) return next;
              if (!node.children || !Array.isArray(node.children)) return null;
              for (const child of node.children) {
                const found = pathToNode(child, id, next);
                if (found) return found;
              }
              return null;
            };

            const selectedChild = findChildById(locationData, childLocationId);
            const path = pathToNode(locationData, childLocationId);
            let ancestorFp = null;
            if (path && path.length) {
              for (let i = path.length - 1; i >= 0; i -= 1) {
                const n = path[i];
                if (n?.floorplan?.url) {
                  ancestorFp = n.floorplan.url;
                  break;
                }
              }
            }

            const childFp = selectedChild?.floorplan?.url;
            const parentFp = locationData?.floorplan?.url;
            const stateFp = state.location.floorplanObject?.url;

            if (!childFp && !parentFp && !ancestorFp && !stateFp) {
              this.errors.push({
                field: 'child_location_id',
                message: 'Choose a location with a floorplan (it can be on the parent or the selected sub-location).',
              });
            }
          }
        }
        // For transit/store, child location is valid without floorplan check
      }
    }
    
    // Validate Code
    if (!bulkCreateMode) {
      const code = document.querySelector('input[name="item[code]"]')?.value;
      if (!code || code.trim() === '') {
        this.errors.push({ field: 'code', message: 'Code is required' });
      }
    }
    
    // Validate Usage
    const usage = document.querySelector('select[name="item[usage]"]')?.value;
    if (!usage || usage === '') {
      this.errors.push({ field: 'usage', message: 'Usage is required' });
    }
    
    // Validate Condition
    const conditionId = document.querySelector('select[name="item[condition_id]"]')?.value;
    if (!conditionId || conditionId === '') {
      this.errors.push({ field: 'condition_id', message: 'Condition is required' });
    }
    
    // Validate Status
    const statusId = document.querySelector('select[name="item[status_id]"]')?.value;
    if (!statusId || statusId === '') {
      this.errors.push({ field: 'status_id', message: 'Status is required' });
    }
    
    // Validate Project
    // const project = document.querySelector('input[name="item[project]"]')?.value;
    // if (!project || project.trim() === '') {
    //   this.errors.push({ field: 'project', message: 'Project is required' });
    // }
    
    // Validate Room
    // const room = document.querySelector('input[name="item[room]"]')?.value;
    // if (!room || room.trim() === '') {
    //   this.errors.push({ field: 'room', message: 'Room / Department / User is required' });
    // }
    
    // Validate Purchase Date
    // const purchaseDate = document.querySelector('input[name="item[purchase_date]"]')?.value;
    // if (!purchaseDate || purchaseDate.trim() === '') {
    //   this.errors.push({ field: 'purchase_date', message: 'Purchase Date is required' });
    // }
    
    // Validate Purchase Price
    // const purchasePrice = document.querySelector('input[name="item[purchase_price_cents]"]')?.value;
    // if (!purchasePrice || purchasePrice.trim() === '') {
    //   this.errors.push({ field: 'purchase_price_cents', message: 'Purchase Price is required' });
    // }
    
    // Validate Warranty
    // const warranty = document.querySelector('select[name="item[warranty]"]')?.value;
    // if (warranty === null || warranty === undefined || warranty === '') {
    //   this.errors.push({ field: 'warranty', message: 'Warranty is required' });
    // }
    
    // Validate Warranty Info
    // const warrantyInfo = document.querySelector('textarea[name="item[warranty_info]"]')?.value;
    // if (!warrantyInfo || warrantyInfo.trim() === '') {
    //   this.errors.push({ field: 'warranty_info', message: 'Warranty Info is required' });
    // }
    
    // Validate Attributes
    const allAttributes = collectAllAttributes();
    const variableAttrs = collectVariableAttributes();
    
    if (true) {
      // Check if all variable attributes are filled
      if (variableAttributes && variableAttributes.length > 0) {
        variableAttributes.forEach(attr => {
          const collectedAttr = variableAttrs.find(a => a.catalogue_association_id === attr.id);
          if (!collectedAttr) {
            this.errors.push({ field: `attribute_${attr.id}`, message: `${attr.owner_attribute.name} is required` });
          }
        });
      }
      
      // Check if fixed attributes are present
      if (fixedAttributes && fixedAttributes.length > 0) {
        const fixedInCollected = allAttributes.filter(a => 
          fixedAttributes.some(fa => fa.id === a.catalogue_association_id)
        );
        if (fixedInCollected.length !== fixedAttributes.length) {
          this.errors.push({ field: 'attributes', message: 'All attributes must be present' });
        }
      }
    }
    return this.errors;
  }

  showFieldErrors(errors, locationMode) {
    // Clear all existing error messages
    document.querySelectorAll('.field-error-message').forEach(el => el.remove());
    document.querySelectorAll('.form-control.-error').forEach(el => el.classList.remove('-error'));
    
    // Show errors for each field
    errors.forEach(error => {
      let fieldElement = null;
      
      // Find the field element based on field name
      if (error.field === 'catalogue_item_id') {
        fieldElement = document.querySelector('input[name="item[catalogue_item_id]"]');
      } else if (error.field === 'catalogue_item_reference') {
        fieldElement = document.querySelector('input[name="catalogue_item_reference"]');
      } else if (error.field === 'location_id') {
        if (locationMode === 'transit') {
          fieldElement = document.querySelector('select[name="item[transit_location_id]"]');
        } else if (locationMode === 'store') {
          fieldElement = document.querySelector('select[name="item[store_location_id]"]');
        } else {
          fieldElement = document.querySelector('select[name="item[location_id]"]');
        }
      } else if (error.field === 'child_location_id') {
        // First try to find the dynamically created select in the children container
        const childrenContainer = document.getElementById('wizard-location-children-container');
        if (childrenContainer) {
          // Look for the first level child select (data-level="1")
          fieldElement = childrenContainer.querySelector('select[data-level="1"]');
        }
        // Fallback to hidden field or named select if dynamic select not found
        if (!fieldElement) {
          fieldElement = document.querySelector('select[name="item[child_location_id]"]') || 
                        document.querySelector('input[name="item[child_location_id]"]');
        }
      } else if (error.field.startsWith('attribute_')) {
        const attrId = error.field.replace('attribute_', '');
        fieldElement = document.querySelector(`[data-attr-id="${attrId}"]`);
      } else {
        fieldElement = document.querySelector(`[name="item[${error.field}]"]`);
      }
      
      if (fieldElement) {
        // Add error class to field
        fieldElement.classList.add('-error');
        
        // Create error message element
        const errorMsg = document.createElement('span');
        errorMsg.className = 'field-error-message';
        errorMsg.style.cssText = 'color: #e74c3c; font-size: 0.875rem; margin-top: 0.25rem; display: block;';
        errorMsg.textContent = error.message;
        
        // Insert error message after the field
        // For child_location_id, insert in the container if it exists
        if (error.field === 'child_location_id') {
          const container = document.getElementById('wizard-location-children-container');
          if (container) {
            // Insert error message after the select element
            fieldElement.parentNode.insertBefore(errorMsg, fieldElement.nextSibling);
          } else {
            // Fallback to standard insertion
            const fieldset = fieldElement.closest('fieldset');
            if (fieldset) {
              fieldset.appendChild(errorMsg);
            } else {
              fieldElement.parentNode.insertBefore(errorMsg, fieldElement.nextSibling);
            }
          }
        } else {
          // Standard insertion for other fields
          const fieldset = fieldElement.closest('fieldset');
          if (fieldset) {
            fieldset.appendChild(errorMsg);
          } else {
            fieldElement.parentNode.insertBefore(errorMsg, fieldElement.nextSibling);
          }
        }
      } else {
        // If field element not found, log for debugging
        console.warn(`Field element not found for error: ${error.field}`, error);
      }
    });
  }

  clearFieldError(fieldName, locationMode) {
    let fieldElement = null;
    
    if (fieldName === 'catalogue_item_id' || fieldName === 'catalogue_item_reference') {
      const clearCatalogueField = (el) => {
        if (!el) return;
        el.classList.remove('-error');
        const wrap = el.closest('.field-group') || el.closest('fieldset') || el.parentElement;
        if (wrap) {
          wrap.querySelectorAll('.field-error-message').forEach((m) => m.remove());
        }
      };
      clearCatalogueField(document.querySelector('input[name="item[catalogue_item_id]"]'));
      clearCatalogueField(document.querySelector('input[name="catalogue_item_reference"]'));
      return;
    } else if (fieldName === 'location_id') {
      if (locationMode === 'transit') {
        fieldElement = document.querySelector('select[name="item[transit_location_id]"]');
      } else if (locationMode === 'store') {
        fieldElement = document.querySelector('select[name="item[store_location_id]"]');
      } else {
        fieldElement = document.querySelector('select[name="item[location_id]"]');
      }
    } else if (fieldName === 'child_location_id') {
      // First try to find the dynamically created select in the children container
      const childrenContainer = document.getElementById('wizard-location-children-container');
      if (childrenContainer) {
        // Look for the first level child select (data-level="1")
        fieldElement = childrenContainer.querySelector('select[data-level="1"]');
      }
      // Fallback to hidden field or named select if dynamic select not found
      if (!fieldElement) {
        fieldElement = document.querySelector('select[name="item[child_location_id]"]') || 
                      document.querySelector('input[name="item[child_location_id]"]');
      }
    } else {
      fieldElement = document.querySelector(`[name="item[${fieldName}]"]`);
    }
    
    if (fieldElement) {
      fieldElement.classList.remove('-error');
      const fieldset = fieldElement.closest('fieldset');
      if (fieldset) {
        const errorMsg = fieldset.querySelector('.field-error-message');
        if (errorMsg) errorMsg.remove();
      }
    }
  }

  clearAllErrors() {
    document.querySelectorAll('.field-error-message').forEach(el => el.remove());
    document.querySelectorAll('.form-control.-error').forEach(el => el.classList.remove('-error'));
  }
}

